import { defineMessages } from 'react-intl';

export default defineMessages({
  affirmLogoAlt: {
    id: 'PaymentMethodStepInfo.affirmLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Affirm',
  },
  affirmLegend: {
    id: 'PaymentMethodStepInfo.affirm.legend',
    description: 'Legend for Affirm rowz',
    defaultMessage: 'Monthly payments with as low as 0% APR financing.',
  },
  acimaLogoAlt: {
    id: 'PaymentMethodStepInfo.acimasLogo.alt',
    description: 'Alternative text to Acima logo',
    defaultMessage: 'Acima',
  },
  amazonPayLogoAlt: {
    id: 'PaymentMethodStepInfo.amazonPay.alt',
    description: 'Alternative text to AmazonPay logo',
    defaultMessage: 'AmazonPay',
  },
  amazonPayTitle: {
    id: 'PaymentMethodStepInfo.amazonPay.title',
    defaultMessage: 'Amazon Pay',
  },
  applePayTitle: {
    id: 'PaymentMethodStepInfo.applePay.title',
    defaultMessage: 'Apple Pay',
  },
  applePayLogoAlt: {
    id: 'PaymentMethodStepInfo.applePay.alt',
    description: 'Alternative text to ApplePay logo',
    defaultMessage: 'ApplePay',
  },
  creditCardRowTitle: {
    id: 'PaymentMethodStepInfo.CreditCardRow.title',
    description: 'Credit Card Row Title',
    defaultMessage: 'Credit Card',
  },
  creditCardLogoAlt: {
    id: 'PaymentMethodStepInfo.CreditCardRow.logo.alt',
    description: 'Credit Card Row logo image alt',
    defaultMessage: 'Credit Card',
  },
  learnMore: {
    id: 'PaymentMethodStepInfo.LearnMore',
    description: 'Learn More legend',
    defaultMessage: 'Learn More',
  },
  paypalPaymentMethod: {
    id: 'PaymentMethodStepInfo.payPal.method',
    defaultMessage: 'Payment Method: PayPal',
  },
  affirmPaymentMethod: {
    id: 'PaymentMethodStepInfo.affirm.method',
    defaultMessage: 'Payment Method: Affirm',
  },
  amazonPaymentMethod: {
    id: 'PaymentMethodStepInfo.amazon.method',
    defaultMessage: 'Payment Method: Amazon Pay',
  },
  applePayPaymentMethod: {
    id: 'PaymentMethodStepInfo.applePay.method',
    defaultMessage: 'Payment Method: Apple Pay',
  },
  payPalLogoAlt: {
    id: 'PaymentMethodStepInfo.payPal.alt',
    description: 'Alternative text to PayPal logo',
    defaultMessage: 'PayPal',
  },
  billingAddress: {
    id: 'PaymentMethodStepInfo.billingAddress',
    defaultMessage: 'Billing Address',
  },
  ending: {
    id: 'PaymentMethodStepInfo.ending',
    defaultMessage: 'Ending in {last4}',
  },
  affirmAdvice: {
    id: 'PaymentMethodStepInfo.affirmAdvice.message',
    defaultMessage:
      'You will be redirected to Affirm to complete your order on the next step.',
  },
  giftCardsApplied: {
    id: 'PaymentMethodStepInfo.giftCardsApplied.message',
    defaultMessage: 'Gift Cards Applied',
  },
  paymentMethod: {
    id: 'PaymentMethodStepInfo.paymentMethod',
    defaultMessage: 'Payment Method:',
  },
  totalPrice: {
    id: 'PaymentMethodStepInfo.totalPrice',
    defaultMessage: 'Total:',
  }
});
